import './_body-view-height';
import './_scroll-to.js';
import './header';
import './_search';
//import './_lazy-image.js';
import './_slideshow.js';
import './_tutorials.js';
import './_skip-header.js';
import './_get-posts.js';
import './_custom-dashboard.js';
import './_accordions.js';
import './_archive.js';

import { initMap } from "./_map";

window.initMap = initMap;
import './_block-market-reports.js';
import './_funds-table.js';
import './_funds-preview.js';
import './_fund-graph.js';
import './_funds-presentation.js';

import './_custom-select.js';